import { ProjectDatasetsTabFragment, ProjectPageFragment } from '@/gql/graphql';
import { RouteObjectWithPlugins, useRenderedRouteLoaderData } from '@/reactRouterPlugins';
import { ProjectPage, projectPageLoader, ProjectPageSkeleton } from './project';
import { ProjectAboutTab } from './projectAboutTab';
import { ProjectDatasetsTab } from './projectDatasetsTab';
import {
  projectNewsAndEventsLoader,
  ProjectNewsAndEventsTab,
  ProjectNewsAndEventsTabSkeleton,
} from './projectNewsAndEventsTab';

const id = 'projectKey';

export const projectKeyRoute: RouteObjectWithPlugins = {
  id,
  gbifRedirect: ({ key } = {}, { gbifOrgLocalePrefix = '' }) => {
    if (typeof key !== 'string' && typeof key !== 'number')
      throw new Error('Invalid key');
    return `${import.meta.env.PUBLIC_GBIF_ORG}${gbifOrgLocalePrefix}/project/${key}`;
  },
  path: 'project/:key',
  loader: projectPageLoader,
  loadingElement: <ProjectPageSkeleton />,
  element: <ProjectPage />,
  isSlugified: true,
  children: [
    {
      index: true,
      element: <ProjectAboutTab />,
    },
    {
      path: 'news',
      element: <ProjectNewsAndEventsTab />,
      loadingElement: <ProjectNewsAndEventsTabSkeleton />,
      loader: projectNewsAndEventsLoader,
    },
    {
      path: 'datasets',
      element: <ProjectDatasetsTab />,
    },
  ],
};

export function useProjectKeyLoaderData() {
  const { data } = useRenderedRouteLoaderData(id) as {
    data: { resource: ProjectPageFragment } & ProjectDatasetsTabFragment;
  };
  return data;
}
